export default "<p>card-with-tabs works!</p>\n"